export default "__VITE_ASSET__5b1a15d4__"